import React, { useState, useEffect } from 'react';
import { Box, Stack, Typography, TextField, IconButton, List, ListItem, ListItemText, ListItemIcon, Divider, InputAdornment, Skeleton, CircularProgress } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Fuse from 'fuse.js';
import JobDetails from "../JobDetails";
import { getStatusColor } from "../../../../utils/ColourStatus";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from 'react-redux';
import { getProfile } from '../../../../utils/api';
import { useWebSocket } from '../../../../components/useWebSocket';
import { customLog } from '../../../../utils/utils';
import EmptySection from '../../../../components/molecules/EmptySection';
import { CLEANING_DIALOG_QUERY_PARAM, DEFAULT_ROBOT_MODEL, FIRE_ALARM_USE_ICON, JOB_TYPE, TASK_MODE_QUERY_PARAM } from '../../../../utils/const';
import { getJobStatusLabel, JobEnums } from '../../../../utils/enums/JobEnums';
import { COLOR } from '../../../../utils/colors';
import cleanIcon from '../../../../assets/cleaning/clean-icon.png';
import { parseAsBoolean, useQueryState } from 'nuqs';
import { DashboardMode } from '../../../../utils/enums/Dashboard';
import { RobotsData } from '../../dashboard';
import { VIEW } from '../../../../utils/breakpoint';
import { useListCleaningJobs } from '../../../../hooks/cleaning';
import { DataCleaningJobType } from '../../../../hooks/cleaning/index.type';
import DetailCleaningJobBoard from './DetailCleaningJobBoard';

interface JobBoardProps {
    handleJobBoardClose: () => void;
    handleSelectedJob: (job: JobDetails2) => void;
    selectedJob: JobDetails2;
    imageHeight: number;
    activeStep: number;
    handleJobSearchField: (event: React.ChangeEvent<HTMLInputElement>) => void;
    searchValue: string;
    listOfJobs: JobData;
    handleBackButton: () => void;
    getJobList: (status: string, page?: number) => void; // Updated to accept status
    hasMoreJobs: boolean;
    handleSetMoreJobs: (value: boolean) => void;
    getRecurringJobs: (pageNumber?: number) => void;
    robotLists: RobotsData;
    isLoadingJobs?: boolean;
}

interface JobDetails2 {
    compartment_pin: string;
    id: number;
    job_type: string;
    job_id: number;
    organisation_id: string;
    load_compartment: number;
    recipient_id: string;
    recipient_location: string;
    recipient_name: string;
    robot_id: string;
    sender_id: string;
    sender_location: string;
    sender_name: string;
    timestamp: number;
    job_status: string;
    order_number: string;
    recurring_type: string;
}

interface JobData {
    [order_number: string]: JobDetails2;
}

const CleaningJobBoard = ({
    handleJobBoardClose,
    defaultSelectedCleaningJob
}: {
    handleJobBoardClose?: () => void,
    defaultSelectedCleaningJob ?: DataCleaningJobType
}) => {
    const [tabValue, setTabValue] = useState(0);
    const [searchValue, setSearchValue] = useState('')
    const tabString = tabValue === 0 ? "in_progress" : tabValue === 1 ? "completed" : tabValue === 2 ? "failed" : ""
    // const listJobs = Object.keys(listOfJobs).map(order_number => ({
    //     ...listOfJobs[order_number]
    // }));

    const [page, setPage] = useState(1)
    const organisation_id = getProfile()?.organisation
    const { data: dataCleaningJob, isLoading: isLoadingJobs, refetch: refetchCleaningJobs } = useListCleaningJobs({
        organisation_id,
        page,
        status: tabString
    })
    const [listJobs, setListJobs] = useState<DataCleaningJobType[]>([])

    const currentData = dataCleaningJob?.data || []
    // const listJobs = dataCleaningJob?.data || []
    const totalPage = dataCleaningJob?.num_pages || 1
    const hasMoreJobs = page + 1 <= totalPage


    const getJobList = (status: string, page = 1) => {
        setPage(page)
    }

    useEffect(() => {
        refetchCleaningJobs()
    }, [page])

    useEffect(() => {
        if(!defaultSelectedCleaningJob){
            return
        }

        setSelectedJob(defaultSelectedCleaningJob)
    }, [defaultSelectedCleaningJob])

    useEffect(() => {
        if (!currentData) {
            return
        }

        if (listJobs.length === 0) {
            setListJobs(currentData)
            return
        }

        if (currentData.length === 0) {
            setListJobs([])
            return
        }

        if (page === 1) {
            setListJobs(currentData)
            return
        }

        const firstCurrentData = currentData[0]
        if (listJobs.map((i) => i.task_id).includes(firstCurrentData.task_id)) {
            return
        }

        setListJobs([
            ...listJobs,
            ...currentData
        ])
    }, [dataCleaningJob])

    const [selectedJob, setSelectedJob] = useState<DataCleaningJobType>()
    const handleJobSearchField = (value: string) => {
        setSearchValue(value)
    }
    const handleSelectedJob = (data: DataCleaningJobType) => {
        setSelectedJob(data)
    }


    const fuse = new Fuse(listJobs, {
        keys: ['task_name'],
        threshold: 0.3
    });

    const [isShowContent, setIsShowContent] = useState(false)

    useEffect(() => {
        setIsShowContent(true)
    }, [])

   
    // Get search results if searchValue is not empty

    // TODO: Remove TMP DUMMY JOB AT TOP
    const searchResultsOriginalData = searchValue ? fuse.search(searchValue).map(result => result.item) : listJobs;
    const searchResults = searchResultsOriginalData

    const pageNumber = useSelector((state: any) => state.jobPage.currentPageNumber);
    const totalPageNumber = useSelector((state: any) => state.jobPage.totalPageNumber);

    // Fetch more jobs
    const fetchMoreJobs = async () => {
        customLog("Fetching more jobs", pageNumber, totalPage, tabValue);
        if (hasMoreJobs && pageNumber + 1 <= totalPage) {
            await getJobList(tabString, pageNumber + 1);
        }
        // else if (tabValue === 2 && hasMoreJobs && pageNumber + 1 <= totalPageNumber) {
        //   await getRecurringJobs(pageNumber + 1);
        // }
    };

    // Handle tab change and query jobs accordingly
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        if (isLoadingJobs) {
            return
        }
        setTabValue(newValue);
        getJobList(tabIndexToCode(newValue), 1);
        // if (newValue === 2) {
        //     getRecurringJobs();
        // }
        // else {
        //     getJobList(newValue === 0 ? "in_progress" : newValue === 1 ? "completed" : "failed");
        // }

    };

    const tabIndexToCode = (value: number) => {
        if (value === 0) {
            return "in_progress"
        }
        if (value === 1) {
            return "completed"
        }
        return "failed"
    }

    const jobOverviewUrl = `${process.env.REACT_APP_WEBSOCKET_URL}/cleaning_job_status/${organisation_id}/`;
    const onJobReceived = () => {
        getJobList(tabIndexToCode(tabValue), 1)
        refetchCleaningJobs()
    }
    useWebSocket(jobOverviewUrl, onJobReceived);

    const emptyTitle = () => {
        if (!!searchValue) {
            return `No Results for '${searchValue}'`
        }
        return tabValue === 0 ? "No Jobs in Progress" : tabValue === 1 ? "No Completed Jobs" : "No Failed Jobs";
    }

    return (
        <>
            {!!selectedJob ? (
                <>
                    <DetailCleaningJobBoard
                        task_id={selectedJob.task_id.toString()}
                        handleBackButton={() => setSelectedJob(undefined)}
                        handleCloseButton={() => {
                            setSelectedJob(undefined)
                            handleJobBoardClose?.()
                        }}
                    />
                </>
                // <JobDetails job={selectedJob} handleJobBoardClose={handleJobBoardClose} imageHeight={imageHeight} activeStep={activeStep} handleBackButton={handleBackButton} />
            ) : (
                <Stack sx={(theme) => ({
                    [theme.breakpoints.up(VIEW.PHONE)]: {
                        position: 'fixed',
                        inset: 0,
                        height: '100dvh',
                        width: '100vw',
                        zIndex: 1100,
                        marginTop: '0px !important',
                        paddingBottom: '24px'
                    },
                    [theme.breakpoints.up(VIEW.TABLET)]: {
                        position: "absolute",
                        top: "60px",
                        left: 'auto',
                        bottom: 'auto',
                        right: "20px",
                        width: "400px",
                        height: '54vh',
                        maxHeight: !!selectedJob ? "450px" : "345px",
                        zIndex: 1005
                    },
                    [theme.breakpoints.up(VIEW.DESKTOP)]: {
                        top: "60px",
                        height: !!selectedJob ? "450px" : "345px",
                    },
                    opacity: isShowContent ? 1 : 0,

                    bgcolor: "white",
                    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                    borderRadius: "10px",
                    overflowY: "hidden",
                    overflowX: "hidden",
                    transition: 'all',
                    transitionDuration: '300ms',
                })}>
                    <Box sx={{ boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)", height: "150px", display: "flex", flexDirection: "column" }}>
                        <Box sx={{ display: "flex", flexDirection: "column", width: "97%", m: 1 }}>
                            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", m: 1 }}>
                                <Typography sx={{ color: "#000", ml: 1, fontWeight: "600", fontSize: "16px", mt: 0.2 }}>
                                    Jobs
                                </Typography>
                                <IconButton onClick={handleJobBoardClose}>
                                    <CloseIcon sx={{ color: "#000", fontSize: "20px" }} />
                                </IconButton>
                            </Box>
                            <TextField
                                id="search-job"
                                placeholder="Search Job ID?"
                                value={searchValue}
                                onChange={(e) => handleJobSearchField(e.target.value || '')}
                                variant="outlined"
                                sx={{ width: "92%", m: "auto", '& .MuiInputBase-root': { height: '50px', fontSize: "14px" }, "& .MuiOutlinedInput-root": { "&.Mui-focused fieldset": { borderColor: "#2C8DFF" } } }}
                                InputProps={{ endAdornment: <InputAdornment position="end"><SearchIcon /></InputAdornment> }}
                            />
                            <Box sx={{ display: "flex", flexDirection: "column", width: "100%", height: "240px" }}>
                                <Tabs
                                    value={tabValue}
                                    onChange={handleTabChange}
                                    sx={{ ml: 2, mt: 1, fontSize: "20px", '.MuiTabs-indicator': { display: 'none' }, '& .MuiTab-root': { color: '#A0A0A0', fontSize: '10px', height: '20px', minHeight: '20px', '&.Mui-selected': { color: '#087D46', backgroundColor: '#00E58E', borderRadius: '30px' } } }}>
                                    <Tab label="In Progress" />
                                    <Tab label="Completed" />
                                    {/* <Tab label="Scheduled" /> */}
                                    <Tab label="Failed" />
                                </Tabs>
                            </Box>
                        </Box>
                    </Box>

                    {/* Display Infinite Scroll only when there are jobs */}
                    {!isLoadingJobs && searchResults.length > 0 && (
                        <Box id="scrollableDiv" sx={(theme) => ({
                            [theme.breakpoints.down(VIEW.TABLET)]: {
                                height: '100%'
                            },
                            [theme.breakpoints.up(VIEW.TABLET)]: {
                                height: '250px'
                            },
                            overflowY: "auto"
                        })}>
                            <InfiniteScroll
                                dataLength={listJobs.length}
                                next={fetchMoreJobs}
                                hasMore={hasMoreJobs}

                                loader={
                                    <Box sx={{ padding: 2 }}>
                                        <Skeleton variant="rectangular" height={50} sx={{ marginBottom: 1 }} />
                                        <Skeleton variant="rectangular" height={50} sx={{ marginBottom: 1 }} />
                                        <Skeleton variant="rectangular" height={50} />
                                    </Box>
                                }
                                endMessage={
                                    <Typography sx={{ textAlign: 'center', mt: 2 }}>
                                        No more Jobs
                                    </Typography>
                                }
                                scrollableTarget="scrollableDiv"
                            >
                                <List>
                                    {searchResults.map((job, index) => (
                                        <React.Fragment key={index}>
                                            <ListItem sx={{ py: 1, '&:hover': { backgroundColor: '#f4f4f4', cursor: 'pointer' }, paddingLeft: "35px" }} onClick={() => handleSelectedJob(job)}>
                                                <ListItemIcon>
                                                    <Stack sx={{ width: "60px", ml: -1, height: "60px", bgcolor: "#f5f5f5", color: "white", fontWeight: "600", borderRadius: "30px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        <img src={cleanIcon} style={{ width: "30px", height: "30px", objectFit: "scale-down" }} />
                                                    </Stack>
                                                </ListItemIcon>
                                                <ListItemText>
                                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "right", ml: 3 }}>
                                                        <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                            <Typography sx={{ color: "#000", fontSize: "16px", fontWeight: "500" }}>
                                                                {/* Job #{job.order_number.slice(-5).toUpperCase()} */}
                                                                {job.task_name}
                                                            </Typography>
                                                            <Typography sx={{ color: "#727272", fontSize: "12px" }}>
                                                                Today, {new Date(job.created_time).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}
                                                            </Typography>
                                                        </Box>
                                                        <Typography sx={{ color: getStatusColor(job.status.toLowerCase().split(' ').join('_')), fontSize: "12px" }}>
                                                            {getJobStatusLabel(job.status)}
                                                            {/* {job.job_status.replace(/_/g, " ").split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")} */}
                                                        </Typography>
                                                    </Box>
                                                </ListItemText>
                                            </ListItem>
                                            {index < searchResults.length - 1 && <Divider sx={{ width: "85%", margin: "auto" }} />}
                                        </React.Fragment>
                                    ))}
                                </List>
                            </InfiniteScroll>
                        </Box>
                    )}

                    {!isLoadingJobs && searchResults.length === 0 && (
                        <Box sx={{ display: 'flex', flexDirection: "column", justifyContent: 'center', alignItems: 'center', height: '100%', mt: 1 }}>
                            <EmptySection
                                title={emptyTitle()}
                                description={!!searchValue ? "No results match your search. Try a different query." : undefined}
                            />
                        </Box>
                    )}

                    {isLoadingJobs && (
                        <Box sx={{ display: 'flex', flexDirection: "column", justifyContent: 'center', alignItems: 'center', height: '100%', mt: 1 }}>
                            <CircularProgress />
                            <Typography
                                sx={{
                                    mt: 2,
                                    color: COLOR.gray[500],
                                    fontSize: "12px",
                                }}
                            >
                                Loading...
                            </Typography>
                        </Box>
                    )}
                </Stack>
            )}
        </>
    );
}

export default CleaningJobBoard;

